import { connect } from 'react-redux'
import LiveSupportWidget from '@bt-react/components/LiveSupportWidget'

const mapStateToProps = state => {

  const webcast = state.webcast.collection[`${state.config.channelId}${state.config.webcastId}`]
  return {
    start: webcast && webcast.status.hasData && webcast.data.start,
    status: state.ui.status
  }

}

export default connect(mapStateToProps)(LiveSupportWidget)
